import React,{useEffect, useState, useRef} from 'react';
import './blackScreen.css';
import {IsLSWork} from '../app/app'
import parse from 'html-react-parser'
import { audio, ambient, musicContinue, musicContinueSwitch, playMusic, pauseMusic, setVolume, transitionVolume, transitionSpeed, stopMusic, isPlaying, playEffects, setVolumeEffects, stopEffects, transitionVolumeEffects, isPlayingEffects, playAmbient, setVolumeAmbient, transitionVolumeAmbient, transitionSpeedAmbient, stopAmbient, playEffectsVN, stopEffectsVN, setVolumeEffectsVN, transitionVolumeEffectsVN, isPlayingEffectsVN, changeMusicSpeed, changeAmbientSpeed} from '../musicEngine/musicEngine';
import typing from'../../m/typing.js'
import notification from'../../m/notification.js'
import whoosh from'../../m/whoosh.js'

function BlackScreen({txt, goNext, end, trailer, goMenu, state, step, setStep, hzAdjuster}) {
  const [isLS, setIsLS] = useState(IsLSWork());
  const [clicked, setClicked] = useState(true);
  const textRef = useRef(null);
  const button = useRef(null);
  const buttonTrailer = useRef(null);
  const skipButton = useRef(false);
  const skipText = useRef(false);
  const texting = useRef(false);
  const whiteScreen = useRef(true);
  const num = useRef(0);
  const wrap = useRef(null);


  useEffect(() => {
    preStart();
    async function preStart(){
    if(!end){
      if(state.current[step] == undefined){
        state.current.splice(step, 1, {blackScreen:true});
        if(isLS){
        localStorage.setItem('stateSC2', JSON.stringify(state.current));
      }
      }
    }
    await waitingFunc(500);
    changeSetting(wrap,"current.style.opacity", 0, "", 0.01);
     start();
   }
},[]);

  //useEffect(() => {
//changeWhite(true);
//},[txt]);

function waitingFunc(t){
  return new Promise(async (resolve, reject) => {
      setTimeout(f,t);
    function f(){
      resolve();
      return;
    }
  });
}
       async function goFurther(){
            return new Promise( async (resolve, reject) => {
              if(end){
                if(isLS){
              //  localStorage.setItem('stepSC', 0);
                //localStorage.setItem('stateSC', JSON.stringify([]));
              }
              }
              await changeSetting(wrap,"current.style.opacity", 0, "", 0.01);
                if(!end){
                  await changeSetting(wrap,"current.style.opacity", 1, "", 0.01)
                  goNext();
                }else{
                  if(isLS){
					localStorage.setItem('stepSC2', step-1);
        }
        await changeSetting(wrap,"current.style.opacity", 1, "", 0.01);
					setStep(prev => prev-1);
                  goMenu();
                }
                if(end){
                //setStep(0);
              //  state.current = [];
              }
                resolve();
              });
            }


async function nextSlide(){
  if(whiteScreen.current){
    return;
  }
  if(skipButton.current){
    skipText.current = true;
    return;
  }
  if(!texting.current){
    stopEffectsVN();
    setVolumeEffectsVN(0.3);
    playEffectsVN(whoosh, false);
    if(num.current == txt.length-1){
      setClicked(false);
      goFurther();
      return;
    }
    texting.current = true;
    await changeSetting(wrap,"current.style.opacity", 1, "", 0.01);
    num.current+=1;
    textRef.current.innerHTML = "";
    button.current.style.display = "none";
    button.current.style.opacity = "0";
    buttonTrailer.current.style.display = "none";
    buttonTrailer.current.style.opacity = "0";
    await changeSetting(wrap,"current.style.opacity", 0, "", 0.01);
    start();
  }
}

async function start(){
  let txtHTML = "";
  let i=0;
  let text = txt[num.current];
  await typeWriter();
  async function typeWriter() {
    return new Promise(async (resolve, reject) => {
    if (i < text.length) {
      if(text.charAt(i) == "<" && text.charAt(i+1) == "b" && text.charAt(i+2) == "r" && text.charAt(i+3) == "/" && text.charAt(i+4) == ">"){
        txtHTML += "<br/>";
        i+=5;
      }else if(text.charAt(i) == "<" && text.charAt(i+1) == "/" && text.charAt(i+2) == "h" && text.charAt(i+3) == "2" && text.charAt(i+4) == ">"){
        txtHTML += "</h2>";
        i+=5;
      }else if(text.charAt(i) == "<" && text.charAt(i+1) == "h" && text.charAt(i+2) == "2" && text.charAt(i+3) == ">"){
        txtHTML += "<h2>";
        i+=4;
      }
      if(i>3){
        skipButton.current = true;
      }
        txtHTML += text.charAt(i);
      textRef.current.innerHTML = txtHTML;
      if(i % 3 == 0){
        setVolumeEffects(0.05);
        playEffects(typing, false);
      }
      i+=1;
      if(skipText.current == false){
        if(i>=text.length){
          if(num.current == txt.length-1 && end){
            button.current.style.display = "block";
            await waitingFunc(300);
            stopEffects();
            setVolumeEffects(0.1);
            playEffects(notification, false);
            await changeSetting(button, "current.style.opacity", 1, "", 0.01);
          }
          if(num.current == txt.length-2 && end && trailer){
            buttonTrailer.current.style.display = "block";
            await waitingFunc(300);
            await changeSetting(buttonTrailer, "current.style.opacity", 1, "", 0.01);
          }
          skipButton.current = false;
          texting.current = false;
          resolve();
           return;
        }
       setTimeout(awaitTypeWriter, 35);
       return;
       async function awaitTypeWriter(){
         await typeWriter();
         resolve();
         return;
       }
    }else if(skipButton.current == true){
      textRef.current.innerHTML = text;
      if(num.current == txt.length-1 && end){
        button.current.style.display = "block";
        await waitingFunc(300);
        stopEffects();
        setVolumeEffects(0.1);
        playEffects(notification, false);
        await changeSetting(button, "current.style.opacity", 1, "", 0.01);
      }
      if(num.current == txt.length-2 && end && trailer){
        buttonTrailer.current.style.display = "block";
        await waitingFunc(300);
        await changeSetting(buttonTrailer, "current.style.opacity", 1, "", 0.01);
      }
        skipButton.current = false;
        skipText.current = false
        texting.current = false;
        resolve();
        return;
      }
      }
  });
  }
}


function changeSetting(obj, setting, changeTo, um, speed, char){
  speed = speed*2*hzAdjuster;
  return new Promise((resolve, reject) => {
    const props = setting
        .split(/[./[\]]/g)
        .filter(p => p);
    const prop = props.pop();
    const parent = props.reduce((result, key) => result[key], obj);
    //
    var i;
    if(setting == "current.style.transform" || setting == "style.transform"){
      i = Math.round(parseFloat(parent[prop].split("(")[1].split(")")[0]));
    }else{
      i = Math.round(parseFloat(parent[prop]));
    }
    let slowDownTrigger = 0;
  //  if(char){//delete
  //slowDownTrigger = Math.round(parseFloat(Math.abs((char.initialPointX[0]-char.destinationPointX)/char.speed)*0.8));//moment of slower of char
  //}
  //  let slowDownCounter=0;
    let slower = 8;
    change();
  function change(){
    //slowDownCounter++;
  //  if(slowDownCounter > slowDownTrigger && char != undefined){ //delete
  //    slower+=3; //slower of char
  //  }
  //  console.log(slower);
    if(i>changeTo){
      i-=speed;
      if(i<changeTo){
        i = changeTo;
        if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
          parent[prop] = "scale("+i+")";
        }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
          parent[prop] = "rotateY("+i+"deg)";
        }else{
          parent[prop] = i+um;
        }
        if(setting == "current.style.opacity" && i == 0){
          whiteScreen.current = false;
        }
        resolve();
        return;
      }
  }else if(i<changeTo){
    i+=speed;
    if(i>changeTo){
      i = changeTo;
      if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
        parent[prop] = "scale("+i+")";
      }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
        parent[prop] = "rotateY("+i+"deg)";
      }else{
        parent[prop] = i+um;
      }
      if(setting == "current.style.opacity" && i == 0){
        whiteScreen.current = false;
      }
      resolve();
      return;
    }
  }else{
    if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
      parent[prop] = "scale("+i+")";
    }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
      parent[prop] = "rotateY("+i+"deg)";
    }else{
      parent[prop] = i+um;
    }
    if(setting == "current.style.opacity" && i == 0){
      whiteScreen.current = false;
    }
    resolve();
    return;
  }
  if((setting == "current.style.transform" || setting == "style.transform") && um == "scale"){
    parent[prop] = "scale("+i+")";
  }else if((setting == "current.style.transform" || setting == "style.transform") && um == "rotateY"){
    parent[prop] = "rotateY("+i+"deg)";
  }else{
    parent[prop] = i+um;
  }
  if(setting == "current.style.opacity" && i == 0){
    whiteScreen.current = false;
  }
requestAnimationFrame(change);
return;
}
});
}


return(
<div className='blkscrn'>
<div className='clickWrap' onClick={clicked? nextSlide : undefined} id='wrap' ref={wrap} style={{opacity:"1"}}></div>
<div style={{width:"100vw"}}>
<div className='txt' ref={textRef}></div>
<a href='https://www.patreon.com/c/almondraf' ref={button} style={{display:"none", opacity:"0"}} target="_blank"><div className="buttonPatreon" style={{clear:"both",zIndex:"20"}}>PATREON</div></a>
<a href='https://www.redgifs.com/watch/purpleexpertbongo' ref={buttonTrailer} style={{display:"none", opacity:"0"}} target="_blank"><div className="buttonTrailer" style={{clear:"both",zIndex:"20"}}>WATCH<h6 style={{fontSize:"13px", textAlign:"center"}}>on <span style={{color:"#d404af"}}>RedGifs</span></h6></div></a>
</div>
</div>
);

}

export default BlackScreen;
